import React from 'react';
import { LockIcon, ShieldCheckIcon } from 'lucide-react';
import { checkoutUrl, mockupUrl, offerAnchor } from '../data/content';
import { pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function FinalClose() {
  return <section className="bg-blue-950 px-4 py-12 md:py-16" data-id="element-63" data-mp="i5hfulcyyebg">
      <div className="mx-auto max-w-3xl text-center" data-id="element-64" data-mp="i72ccgiug7by">
        <p className="text-[11px] font-black uppercase tracking-[.25em] text-sky-300 md:text-xs" data-id="element-65" data-mp="1fszqy2u3rsim">One last question</p>
        <h2 className="mx-auto mt-3 max-w-2xl text-xl font-black uppercase leading-snug text-white md:text-3xl" data-id="element-66" data-mp="1auy4d7xgxb2e">
          How much easier would your work be with your sports massage resources already organized?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/75" data-id="element-67" data-mp="111r4g2lhyn9p">
          You can continue searching through different notes, courses, and scattered technique references. Or you can
          have one organized professional system covering:
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-black uppercase tracking-wider text-sky-300 md:text-base" data-id="element-68" data-mp="nqn9tnc4yi5y">
          Session planning. Techniques. Protocols. Complete sessions. Professional tools.
        </p>

        <OfferLink className="mx-auto mt-8 max-w-[300px]" href={offerAnchor} label="Complete Sports Massage Bundle offer" data-id="element-69" data-mp="dz97z8wpp69n">
          <img src={mockupUrl} alt="Complete Sports Massage Bundle 3D mockup" className="w-full rounded-2xl bg-white object-contain p-3 shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-70" data-mp="4yuh7u0zayyr" />
        </OfferLink>

        <p className="mt-6 text-lg font-black uppercase text-white md:text-2xl" data-id="element-71" data-mp="3r85fbo4frd37">Complete Sports Massage Bundle</p>
        <p className="mt-1 text-xs font-extrabold uppercase tracking-wide text-yellow-300" data-id="element-72" data-mp="1peobkvjfewdq">
          5 Complete Volumes + 5 Practical Bonuses
        </p>
        <p className="mt-5 text-sm font-semibold text-white/85" data-id="element-73" data-mp="1ud92238vm1oz">Get the complete professional system today.</p>

        <div className="mt-4" data-id="element-74" data-mp="1sxwwscf175ij">
          <Button href={checkoutUrl} size="lg" subtext="Instant Access • Digital Delivery" data-id="element-75" data-mp="1nxinys5lvrjg">
            Get instant access — ${pricing.price}
          </Button>
        </div>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/80" data-id="element-76" data-mp="1j0igcct3ygq8">
          <li className="flex items-center gap-1.5" data-id="element-77" data-mp="2bmtpibus5pyn">
            <ShieldCheckIcon className="h-4 w-4 text-sky-300" aria-hidden="true" data-id="element-78" data-mp="2bmblgt1vm7g6" /> 7-Day Guarantee
          </li>
          <li className="flex items-center gap-1.5" data-id="element-79" data-mp="26q3a7qqsuyea">
            <LockIcon className="h-4 w-4 text-sky-300" aria-hidden="true" data-id="element-80" data-mp="21w8ko6oijp7a" /> Secure Payment
          </li>
        </ul>
      </div>
    </section>;
}